import React from 'react';
import {Button, Dialog, DialogContent, DialogTitle} from "@mui/material";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";

const ModalConfirm = ({title, modalOpen, handleClose, handleSubmit, action, loading, children}) => {
    return (
        <div>
            <Dialog open={modalOpen} onClose={handleClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {children}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: children ? 16 : 0,
                    }}>
                        <ButtonExit text={"Отменить"} onClick={handleClose}/>
                        <ButtonAdd loading={loading} text={action} onClick={handleSubmit}/>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ModalConfirm;

